module.exports = {
          srcSet: __webpack_public_path__ + "2f4803f3278a5830903483354d2229f2-1859.png"+" 1859w",
          images:[ {path: __webpack_public_path__ + "2f4803f3278a5830903483354d2229f2-1859.png",width: 1859,height: 836}],
          src: __webpack_public_path__ + "2f4803f3278a5830903483354d2229f2-1859.png",
          toString:function(){return __webpack_public_path__ + "2f4803f3278a5830903483354d2229f2-1859.png"},
          
          width: 1859,
          height: 836
        }